interface IPropertyEntrataUrls {
  [key: number]: string;
}

// Mirror of web mapping
export const PROPERTY_ENTRATA_URLS: IPropertyEntrataUrls = {
  350: "https://1047commonwealthavenue.residentportal.com/auth",
  354: "https://academy65.residentportal.com/auth",
  347: "https://thedeanreno.residentportal.com/auth",
  348: "https://frisco.residentportal.com/auth",
  357: "https://riseatnorthgateapts.residentportal.com/auth",
  346: "https://shortbreadlofts.residentportal.com/auth",
  356: "https://sovaks.residentportal.com/auth",
  349: "https://academycampustown.residentportal.com/auth",
  351: "https://academycampustown.residentportal.com/auth",
  352: "https://academycampustown.residentportal.com/auth",
  353: "https://academycampustown.residentportal.com/auth",
  345: "https://academylincoln.residentportal.com/auth",
  360: "https://thecharles.residentportal.com/auth",
  355: "https://thedeancampustown.residentportal.com/auth",
  359: "https://venueatnorthcampus.residentportal.com/auth",
  358: "https://torre.residentportal.com/auth",
};

export const getEntrataUrl = (propertyId?: number | null) =>
  (propertyId != null ? PROPERTY_ENTRATA_URLS[propertyId] : undefined);


